import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 24px;
  width: 100%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 24px 24px 0 0;
  position: sticky;
  top: 0;
  z-index: 10;
  
  h3 {
    margin: 0;
    color: white;
    font-size: 16px;
    font-weight: 700;
  }
  
  p {
    margin: 8px 0 0 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ModalBody = styled.div`
  padding: 16px;
`;

export const GrupoOption = styled.div<{ isDefault?: boolean }>`
  padding: 16px;
  border: 2px solid ${props => props.isDefault ? '#10b981' : '#e2e8f0'};
  border-radius: 14px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s;
  background: ${props => props.isDefault ? 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)' : 'white'};
  
  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const GrupoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

export const GrupoNome = styled.span<{ isDefault?: boolean }>`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.isDefault ? '#166534' : '#1e293b'};
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const GrupoValor = styled.span<{ showValue?: boolean }>`
  font-size: 16px;
  font-weight: 700;
  color: ${props => props.showValue ? '#10b981' : '#94a3b8'};
`;

export const GrupoObs = styled.p`
  margin: 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
`;

export const DefaultBadge = styled.span`
  background: #10b981;
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  
  .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #e2e8f0;
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 12px;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  p {
    margin: 0;
    font-size: 14px;
    color: #64748b;
  }
`;

export const Divider = styled.div`
  border-top: 1px solid #e2e8f0;
  margin: 16px 0;
  position: relative;
  
  span {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    padding: 0 12px;
    font-size: 11px;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

